// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pecharunt: PokeData = {
  "id": 1025,
  "name": "pecharunt",
  "height": 3,
  "weight": 3,
  "base_experience": 300,
  "types": [
    PokeType.POISON,
    PokeType.GHOST
  ],
  "api_moves": [
    "toxic",
    "recover",
    "withdraw",
    "smog",
    "poison-gas",
    "destiny-bond",
    "shadow-ball",
    "memento",
    "astonish",
    "fake-tears",
    "nasty-plot",
    "parting-shot",
    "malignant-chain"
  ],
  "moves": [
    "poison-gas",
    "shadow-ball",
    "shadow-sneak",
    "lick",
    "poltergeist",
    "curse",
    "confuse-ray",
    "poison-fang",
    "soul-sacrifice",
    "toxic-spikes",
    "shadow-claws",
    "shadow-dagger",
    "sludge-bomb"
  ],
  "evolution_chain": {
    "id": 549,
    "item": null,
    "species": [
      {
        "name": "pecharunt",
        "order": 1027,
        "types": [
          PokeType.POISON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 150,
    "speed": 125,
    "ability_power": 125
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
